module.exports = __webpack_public_path__ + "img/ring_r_o_0_0@3x.8a5be9da.png";